import { memo } from "react"
import OrgStaffSummary from "../OrgStaffSummary"
import StaffSelector from "./components/StaffSelector"
import StaffMenu from "./components/StaffMenu"

// Create a regular function component
function StaffSidebar() {
  return (
    <div>
      <OrgStaffSummary />
      <div style={{ marginBottom: "12px" }}>
        <StaffSelector />
      </div>
      <StaffMenu />
    </div>
  )
}

// Export the component wrapped in React.memo to prevent unnecessary renders
export default memo(StaffSidebar)
